import { render, staticRenderFns } from "./GTARow.vue?vue&type=template&id=a02d984a"
import script from "./GTARow.vue?vue&type=script&lang=js"
export * from "./GTARow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports